<template>
	<ts-loading-banner :loading="loading">
		<div>
			<form class="form-horizontal">
				<h1 class="section-divider">
					{{ $t('school.academic.operation.profile_mgt.studentProfile.father') }}
				</h1>
				<div class="row mb-3">
					<div class="col-sm-12 col-lg-6 col-md-12">
						<div class="form-group row">
							<label class="col-md-4 form-col-label control-label text-right ts-text-xs">
								{{
									$t(
										'school.academic.operation.profile_mgt.studentProfile.nameKh'
									)
								}}
							</label>
							<div class="col-md-7">
								<input type="text" class="form-control" v-model.trim="model.father_name_kh" />
							</div>
						</div>
						<div class="form-group row">
							<label class="col-md-4 form-col-label control-label text-right required ts-text-xs">
								{{
									$t(
										'school.academic.operation.profile_mgt.studentProfile.nameEn'
									)
								}}</label>
							<div class="col-md-7">
								<input type="text" class="form-control" v-model.trim="model.father_name_en"
									@input="onFatherNameInput(model.father_name_en)" />
								<div class="validate ts-text-xs">
									{{ errors.first('father_name_en') }}
								</div>
							</div>
						</div>
						<div class="form-group row">
							<label class="col-md-4 form-col-label control-label text-right ts-text-xs">
								{{
									$t('school.academic.operation.profile_mgt.parentProfile.phoneLineOne')
								}}
							</label>
							<div class="col-md-7">
								<input type="text" class="form-control" v-model.trim="model.father_phone1" />
							</div>
						</div>
					</div>
					<div class="col-sm-12 col-lg-6 col-md-12">
						<div class="form-group row">
							<label class="col-md-4 form-col-label control-label text-right required ts-text-xs"></label>
							<div class="col-md-7 ts-text-xs">
								<ts-checkbox v-model="model.father_allow_pickup">{{
									$t(
										'school.academic.operation.profile_mgt.parentProfile.autoCreateCard'
									)
								}}</ts-checkbox>
							</div>
						</div>
						<div class="form-group row">
							<label class="col-md-4 form-col-label control-label text-right required ts-text-xs"> </label>
							<div class="col-md-7 ts-text-xs">
								<ts-checkbox v-model="model.father_login" @change="onIsFatherLogin">{{
									$t(
										'school.academic.operation.profile_mgt.parentProfile.autoCreateLoginName'
									)
								}}</ts-checkbox>
							</div>
						</div>
						<div class="form-group row">
							<label class="col-md-4 form-col-label control-label text-right ts-text-xs">
								{{ $t('school.academic.operation.profile_mgt.parentProfile.loginName') }}
								<span class="validate" v-if="model.father_login">*</span>
							</label>
							<div class="col-md-7">
								<input v-model="model.father_login_name" type="text" class="form-control" />
							</div>
						</div>
					</div>
				</div>
				<h1 class="section-divider">
					{{ $t('school.academic.operation.profile_mgt.studentProfile.mother') }}
				</h1>
				<div class="row mb-3">
					<div class="col-sm-12 col-lg-6 col-md-12">
						<div class="form-group row">
							<label class="col-md-4 form-col-label control-label text-right ts-text-xs">
								{{
									$t(
										'school.academic.operation.profile_mgt.studentProfile.nameKh'
									)
								}}
							</label>
							<div class="col-md-7">
								<input type="text" class="form-control" v-model.trim="model.mother_name_kh" />
							</div>
						</div>
						<div class="form-group row">
							<label class="col-md-4 form-col-label control-label text-right required ts-text-xs">
								{{
									$t(
										'school.academic.operation.profile_mgt.studentProfile.nameEn'
									)
								}}</label>
							<div class="col-md-7">
								<input type="text" class="form-control" v-model.trim="model.mother_name_en"
									@input="onMotherNameInput(model.mother_name_en)" />
								<div class="validate ts-text-xs" v-if="errors.has('mother_name_en')">
									{{ errors.first('mother_name_en') }}
								</div>
							</div>
						</div>
						<div class="form-group row">
							<label class="col-md-4 form-col-label control-label text-right ts-text-xs">
								{{
									$t('school.academic.operation.profile_mgt.parentProfile.phoneLineOne')
								}}
							</label>
							<div class="col-md-7">
								<input type="text" class="form-control" v-model.trim="model.mother_phone1" />
							</div>
						</div>
					</div>
					<div class="col-sm-12 col-lg-6 col-md-12">
						<div class="form-group row">
							<label class="col-md-4 form-col-label control-label text-right required ts-text-xs"></label>
							<div class="col-md-7 ts-text-xs">
								<ts-checkbox v-model="model.mother_allow_pickup">{{
									$t(
										'school.academic.operation.profile_mgt.parentProfile.autoCreateCard'
									)
								}}</ts-checkbox>
							</div>
						</div>
						<div class="form-group row">
							<label class="col-md-4 form-col-label control-label text-right required ts-text-xs"> </label>
							<div class="col-md-7 ts-text-xs">
								<ts-checkbox v-model="model.mother_login" @change="onIsMotherLogin">{{
									$t(
										'school.academic.operation.profile_mgt.parentProfile.autoCreateLoginName'
									)
								}}</ts-checkbox>
							</div>
						</div>
						<div class="form-group row">
							<label class="col-md-4 form-col-label control-label text-right ts-text-xs">
								{{ $t('school.academic.operation.profile_mgt.parentProfile.loginName') }}
								<span class="validate" v-if="model.mother_login">*</span>
							</label>
							<div class="col-md-7">
								<input v-model="model.mother_login_name" type="text" class="form-control" />
							</div>
						</div>
					</div>
				</div>
				<div class="ts-mt-2 ts-text-right">
					<ts-button class="mr-2" @click="cancel">{{ $t('cancel') }}</ts-button>
					<ts-button outline color="primary" :waiting="waiting" @click="onSaveParent">{{
						$t('save')
					}}</ts-button>
				</div>
			</form>
		</div>
	</ts-loading-banner>
</template>
  
<script>
import { Errors } from 'form-backend-validation'
export default {
	name: 'formParent',
	data() {
		return {
			waiting: false,
			errors: new Errors(),
			loading: false,
			model: {
				student_parent_id: null,
				father_name_kh: '',
				father_name_en: '',
				father_phone1: '',
				father_login: true,
				mother_name_kh: '',
				mother_name_en: '',
				mother_login: true,
				mother_phone1: '',
				father_login_name: '',
				mother_login_name: '',
				father_allow_pickup: true,
				mother_allow_pickup: true,
				not_type_list: [],
				agreement_cat_id: '',
				agreement_attached_file: '',
				agreement_display_name: '',
				is_agreed: false,
				file: ''
			},
		}
	},
	methods: {
		onIsFatherLogin(value) {
			if (value == true && this.model.father_name_en !== '') {
				this.model.father_login_name = this.model.father_name_en
					.split(' ')
					.join('.')
			} else {
				this.model.father_login_name = ''
			}
		},
		onIsMotherLogin(value) {
			if (value == true && this.model.mother_name_en !== '') {
				this.model.mother_login_name = this.model.mother_name_en
					.split(' ')
					.join('.')
			} else {
				this.model.mother_login_name = ''
			}
		},
		onFatherNameInput(value) {
			if (value !== '' && this.model.father_login == true) {
				this.model.father_login_name = value.split(' ').join('.')
			} else {
				this.model.father_login_name = ''
			}
		},
		onMotherNameInput(value) {
			if (value !== '' && this.model.mother_login == true) {
				this.model.mother_login_name = value.split(' ').join('.')
			} else {
				this.model.mother_login_name = ''
			}
		},
		cancel() {
			this.$emit('cancel')
		},
		async onSaveParent() {
			this.waiting = true;
			this.$store
				.dispatch("studentProfile/addParent", this.model)
				.then(response => {
					this.$emit('onCreated', {
						father_name_en: response.father_name_en,
						mother_name_en: response.mother_name_en,
						student_parent_id: response.student_parent_id
					})
					this.$toasted.success(response.message)
					this.cancel()
				})
				.catch((error) => {
					this.$toasted.error(error.message)
					this.errors = new Errors(error.errors)
				})
				.finally(() => {
					this.waiting = false
				})

		},
	},
	watch: {
		validate: {
			handler() {
				this.errors = new Errors(this.validate.errors)
			},
			deep: true,
		},
	}
}
</script>
  